import React, { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import * as PropTypes from 'prop-types';
import get from 'lodash/get';
import DocumentReviewGrid from './components/DocumentReviewGridComponent';
import styles from './styles.modules.less';
import LeftNavFilter from './components/LeftNavComponent/index';
import store from '../reviews-modal/store';
import ROUTE from './constants/route';
import { filterParams, USER } from './helper';
import { ITEMS_MENU } from './constants/left-nav';

const USER_ID = USER.id;

const Reviews = (props) => {
  const { route = ROUTE.reviews } = props;
  const isInboxRoute = route === ROUTE.inbox;
  const allReviewsSelectedLabel = get(ITEMS_MENU, '[0].label', '');
  const reviewsAssignMeSelectedLabel = get(ITEMS_MENU, '[1].label', '');
  const initialSelectedFilter = isInboxRoute
    ? reviewsAssignMeSelectedLabel
    : allReviewsSelectedLabel;

  const [selectedFilter, setSelectedFilter] = useState(initialSelectedFilter);
  const [leftNavParam, setLeftNavParam] = useState(
    route === ROUTE.inbox ? filterParams({ member_id: USER_ID }) : {}
  );

  const [filterFlyoutParam, setFilterFlyoutParam] = useState({});
  const [searchValue, setSearchValue] = useState('');

  const getFilterCondition = (e) => {
    setFilterFlyoutParam(e.detail?.filterData);
  };
  useEffect(() => {
    document.addEventListener('filter-flyout-change', getFilterCondition);
    return () => {
      document.removeEventListener(
        'filter-flyout-change',
        getFilterCondition,
        false
      );
    };
  }, []);

  const handleDebounceSearch = ({ detail }) => {
    setSearchValue(detail);
  };

  useEffect(() => {
    const handleSearchEvent = (e) => handleDebounceSearch(e);
    document.addEventListener(
      'document-reviews-search-input',
      handleSearchEvent
    );
    return () => {
      document.removeEventListener(
        'document-reviews-search-input',
        handleSearchEvent,
        false
      );
    };
  }, []);

  const handleChangeParams = (data) => {
    const { param, title } = data;
    setLeftNavParam(param);
    setSelectedFilter(title);
  };

  return (
    <Provider store={store}>
      <div className={styles['review-component']}>
        <div className={styles['review-component__reviewList']}>
          <LeftNavFilter
            defaultLeftNav={isInboxRoute ? 1 : 0}
            changeFilterParam={handleChangeParams}
            filterFlyoutParam={filterFlyoutParam}
          />
        </div>
        <div className={styles['review-component__reviewGrid']}>
          <div className={styles['review-component__reviewHeader']}>
            <div className={styles['review-component__title-ctn']}>
              <span className={styles['review-component__reviewsTitle']}>
                {window.location.href.includes('reviews-proofing')
                  ? 'Reviews & Proofing'
                  : 'Reviews'}
              </span>
              <span className={styles['review-component__reviewsFilter']}>
                {selectedFilter}
              </span>
            </div>
            {props.children}
          </div>
          <DocumentReviewGrid
            emptyReviewScope="reviews"
            leftNavParam={leftNavParam}
            filterFlyoutParam={filterFlyoutParam}
            searchValue={searchValue}
          />
        </div>
      </div>
    </Provider>
  );
};

Reviews.propTypes = {
  route: PropTypes.string,
  children: PropTypes.node,
};
export default Reviews;
